import { breakpoints } from "../constants/breakpoints/breakpoints.js";
import { useWindowSize } from "../custom/components/smileview-section/hooks/useWindowSize.js";
import "react";
const useResponsive = () => {
  const { width = 0 } = useWindowSize();
  const isMobile = width < breakpoints.values.md;
  const isTablet = width >= breakpoints.values.md && width < breakpoints.values.lg;
  const isDesktop = width >= breakpoints.values.lg;
  return { isMobile, isTablet, isDesktop };
};
export {
  useResponsive
};
